/**
 * Group Operations Navigation Utilities
 * Helper functions for navigating to group operations routes
 */

import { NavigateFunction } from 'react-router-dom';

export interface GroupOperationsNavigationUtils {
  navigateToCreateGroup: () => void;
  navigateToDuplicateGroup: (groupId: number) => void;
  navigateToEditGroup: (groupId: number) => void;
}

/**
 * Creates navigation utilities for group operations
 * @param navigate - React Router navigate function
 * @returns Object with navigation utility functions
 */
export const createGroupOperationsNavigation = (
  navigate: NavigateFunction
): GroupOperationsNavigationUtils => {
  return {
    /**
     * Navigate to create group page
     */
    navigateToCreateGroup: () => {
      navigate('/group-operations/create');
    },

    /**
     * Navigate to duplicate group page
     * @param groupId - ID of the group to duplicate
     */
    navigateToDuplicateGroup: (groupId: number) => {
      navigate(`/group-operations/duplicate/${groupId}`);
    },

    /**
     * Navigate to edit group page
     * @param groupId - ID of the group to edit
     */
    navigateToEditGroup: (groupId: number) => {
      navigate(`/group-operations/edit/${groupId}`);
    },
  };
};

/**
 * Route path constants for group operations
 */
export const GROUP_OPERATIONS_ROUTES = {
  CREATE: '/group-operations/create',
  DUPLICATE: (groupId: number) => `/group-operations/duplicate/${groupId}`,
  EDIT: (groupId: number) => `/group-operations/edit/${groupId}`,
} as const;